/* LBF — sous-accordéons Familles / Saisons, mobile + tablette uniquement. */
(function () {
  'use strict';

  function isMobileMenu() {
    return window.matchMedia('(max-width: 1023px)').matches;
  }

  function directChild(item, selector) {
    var child = item && item.firstElementChild;
    while (child) {
      if (child.matches && child.matches(selector)) return child;
      child = child.nextElementSibling;
    }
    return null;
  }

  function setLevel2State(item, open) {
    if (!item) return;
    var trigger = directChild(item, 'a.level2-title');
    var indicator = directChild(item, '.collapsible.level2');
    var dropdown = directChild(item, '.site-nav--dropdown');

    item.classList.toggle('lbf-level2-open', open);
    if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (indicator) {
      indicator.classList.toggle('active', open);
      indicator.setAttribute('aria-hidden', 'true');
    }
    if (dropdown) {
      if (open) dropdown.style.setProperty('display', 'block', 'important');
      else dropdown.style.removeProperty('display');
    }
  }

  function closeLevel2(scope, except) {
    if (!scope) return;
    var items = scope.querySelectorAll('.site-nav--dropdown > li.site-nav--has-dropdown');
    for (var i = 0; i < items.length; i += 1) {
      if (items[i] !== except) setLevel2State(items[i], false);
    }
  }

  function level2ItemFromTarget(target) {
    if (!target || !target.closest) return null;
    var trigger = target.closest('a.level2-title');
    var indicator = target.closest('.collapsible.level2');
    var control = trigger || indicator;
    if (!control) return null;
    var item = control.parentElement;
    if (!item || !item.classList.contains('site-nav--has-dropdown') || item.classList.contains('site-nav-first-level')) return null;
    return item;
  }

  document.addEventListener('click', function (event) {
    if (!isMobileMenu()) return;
    var nav = document.getElementById('accessibleNav');
    if (!nav || !nav.contains(event.target)) return;

    var item = level2ItemFromTarget(event.target);
    if (!item) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var parentDropdown = item.parentElement;
    var shouldOpen = !item.classList.contains('lbf-level2-open');
    closeLevel2(parentDropdown, item);
    setLevel2State(item, shouldOpen);
  }, true);

  function resetClosedTopLevels() {
    if (!isMobileMenu()) return;
    var nav = document.getElementById('accessibleNav');
    if (!nav) return;
    var topItems = nav.querySelectorAll(':scope > li.site-nav-first-level.site-nav--has-dropdown');
    for (var i = 0; i < topItems.length; i += 1) {
      if (!topItems[i].classList.contains('nav-hover')) closeLevel2(topItems[i]);
    }
  }

  var nav = document.getElementById('accessibleNav');
  if (nav && window.MutationObserver) {
    var observer = new MutationObserver(resetClosedTopLevels);
    observer.observe(nav, { attributes: true, subtree: true, attributeFilter: ['class'] });
  }

  window.addEventListener('resize', resetClosedTopLevels, { passive: true });
  document.addEventListener('shopify:section:load', resetClosedTopLevels);
}());
